import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import type { GA4EventParameters } from "@utils/google-analytics-4.type";
import autobind from "autobind-decorator";
import React from "react";

export interface PureMeasureComponentProps {
	ga4Event?: GA4EventParameters;
}

export interface PureMeasureComponentState {}

export type SendEventModifier = (parameters: Record<string, any>) => Record<string, any>;

export abstract class PureMeasureComponent<
	Props extends PureMeasureComponentProps = PureMeasureComponentProps,
	State extends PureMeasureComponentState = PureMeasureComponentState,
> extends React.Component<Props, State> {
	private readonly instanceId;
	protected buttonId: string;

	public constructor(props: Props) {
		super(props);

		this.instanceId = props?.ga4Event?.instanceId || GoogleAnalytics4.generateId("id");
	}

	protected getCommonEventParameters(): Partial<GA4EventParameters> {
		const { ga4Event = { componentName: undefined } } = this.props;

		const localComponentName = this.getComponentName();
		const componentName = [
			ga4Event.componentName,
			ga4Event.componentName !== localComponentName && localComponentName,
		]
			.filter(Boolean)
			.join("/");

		return {
			instanceId: this.instanceId,
			...ga4Event,
			componentName,
		};
	}

	@autobind
	protected sendEvent(name: string, parameters: Record<string, any> = {}): void {
		GoogleAnalytics4.sendEvent(name, {
			...this.getCommonEventParameters(),
			...parameters,
		});
	}
	protected abstract getComponentName(): string;
}
